import { Table } from "antd";
import dayjs from "dayjs";

const InvoiceSuffixInvList = ({ invoiceData }) => {
  const dataSource = invoiceData?.billedSuffixInvs?.map((billedInv, index) => {
    // Get the corresponding suffix inventory directly using index
    const suffixInv = invoiceData?.suffixInventories[index];

    return {
      ...billedInv,
      vendor: suffixInv?.vendor || "-",
      suffixCode: suffixInv?.suffixCode || "-",
      suffixInfo: suffixInv?.suffixInfo || "-",
      purchaseRate: suffixInv?.purchaseRate || 0,
    };
  });

  const columns = [
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      align: "center",
    },
    {
      title: "Suffix Code",
      dataIndex: "suffixCode",
      key: "suffixCode",
      align: "center",
    },
    {
      title: "Suffix Info",
      dataIndex: "suffixInfo",
      key: "suffixInfo",
      align: "center",
    },
    {
      title: "Purchase Rate",
      dataIndex: "purchaseRate",
      key: "purchaseRate",
      align: "center",
    },
    {
      title: "Billing Amount",
      dataIndex: "amount",
      key: "amount",
      align: "center",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      align: "center",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      align: "center",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
    },
  ];

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
            textAlign: "center",
          }}
        />
      ),
    },
  };

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      components={components}
      scroll={{ x: "max-content" }}
    />
  );
};

export default InvoiceSuffixInvList;
